// import wixData from 'wix-data';

$w.onReady(function () {

	// getRepeaterData();

});

// async function getRepeaterData() {
// 	await wixData.query('Features')
// 		.eq('category', 'MARKETING & SEO')
// 		.ascending('order')
// 		.find()
// 		.then(results => {
// 			assignRepeaterData(results.items);
// 		});
// }

// function assignRepeaterData(queryData) {
// 	const repeater = $w('#repeater1');
// 	repeater.data = queryData;
// 	repeater.forEachItem(($item, itemData) => {
// 		$item('#title').text = itemData.featureName;
// 		$item('#description').text = itemData.description;
// 	});
// }